module.exports = __webpack_public_path__ + "img/mr.e12cbc42.svg";